<a class="whatsapp-chat" href="https://wa.me/5491149796358" *ngIf="visibility">
  <img class="icon" src="assets/icons/whatsapp-icon.svg" alt="" />
</a>
